import { render, staticRenderFns } from "./ReactMountDescontoB2B.vue?vue&type=template&id=197cccd0"
import script from "./ReactMountDescontoB2B.vue?vue&type=script&lang=ts"
export * from "./ReactMountDescontoB2B.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197cccd0')) {
      api.createRecord('197cccd0', component.options)
    } else {
      api.reload('197cccd0', component.options)
    }
    module.hot.accept("./ReactMountDescontoB2B.vue?vue&type=template&id=197cccd0", function () {
      api.rerender('197cccd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountDescontoB2B.vue"
export default component.exports